import { Input } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Output } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-default-thread-group',
  templateUrl: './default-thread-group.component.html',
  styleUrls: ['./default-thread-group.component.less']
})
export class DefaultThreadGroupComponent implements OnInit {
  threadGroupForm: any;
  errorDiv = false;
  errorMessage = '';
  @Input() readTestcase: any;
  // @Input() data: any;
  @Input() edited: any;
  @Output() showDistributed: EventEmitter<any> = new EventEmitter();
  @Output() cancelCreation: EventEmitter<any> = new EventEmitter();
  @Output() notifyParent: EventEmitter<any> = new EventEmitter();
  _data: any

  @Input() set data(value: any) {
   this._data = value
   this.threadGroupForm.patchValue(this._data);

  }

  constructor(private formBuilder: FormBuilder) {
    this.setForm();
  }

  ngOnInit() {
    if(this.data !== null && this.data !== undefined) {
      this.threadGroupForm.patchValue(this._data);
    }
  }

  setForm() {
    this.threadGroupForm = this.formBuilder.group({
        duration: [1],
        noOfUsers: [1, [Validators.required, Validators.min(1)]],
        rampUp: [0, [Validators.required, Validators.min(0)]],
        iteration : [false],
        iterationCount: [1]
    });
  }

  saveConfiguration() {
    let tempObject = this.threadGroupForm.value;
    this.errorMessage = '';
    if(tempObject.iteration){
      if(tempObject.iterationCount > 0){
        this.errorDiv = false;
      this.errorMessage = '';
      this.notifyParent.emit({ data : tempObject, edited :  this.edited });
      } else {
        this.errorDiv = true;
        this.errorMessage = 'Iteration Count cannot be less than 1'
      }
      }else { 
        if(tempObject.duration > 0){
          this.errorDiv = false;
            this.notifyParent.emit({ data : tempObject, edited :  this.edited });
        } else {
          this.errorDiv = true;
          this.errorMessage = 'Duration cannot be less than 1'
        }
      }
  }

  updateConfiguration() {
    let tempObject = this.threadGroupForm.value;
      if(tempObject.iteration){
        if(tempObject.iterationCount > 0){
          this.errorDiv = false;
        this.errorMessage = '';
        this.notifyParent.emit({ data : tempObject, edited :  this.edited });
        } else {
          this.errorDiv = true;
          this.errorMessage = 'Iteration Count cannot be less than 1'
        }
        }else { 
          if(tempObject.duration > 0){
            this.errorDiv = false;
              this.notifyParent.emit({ data : tempObject, edited :  this.edited });
          } else {
            this.errorDiv = true;
            this.errorMessage = 'Duration cannot be less than 1'
          }
        }
  }

  cancelThreadGroupCreation() {
    this.threadGroupForm.reset();
    this.cancelCreation.emit();
  }
}
